import { useState } from 'react'
import { Button, Alert } from 'reactstrap'
import { getToken } from '../../utils'
import { FaPrint } from 'react-icons/fa'

export default function PDFLink({ url }) {
  console.log('PDFLink rendered')

  const [errors, setErrors] = useState()

  function handleClick() {
    function tokenSuccess(jwt) {
      console.log(jwt)
      const link = document.createElement('a')
      document.body.appendChild(link)

      const delimiter = url.indexOf('?') > -1 ? '&' : '?'
      link.href = `${url}${delimiter}jwt=${jwt}`
      link.setAttribute('type', 'hidden')
      link.setAttribute('target', '_blank')
      link.click()
    }
    function tokenError(error) {
      console.log('PDFLink: ', JSON.stringify(error))
      setErrors(error)
    }
    getToken(tokenSuccess, tokenError)
  }

  if (errors) {
    <Alert color="danger">{errors}</Alert>
  }
  return (
    <Button data-cy='pdf-link' className="pdf-link" color="primary" onClick={handleClick}><FaPrint /> Print View</Button>
  )
}

// const params = new URLSearchParams(window.location.search)
// const inputs = params.get('inputs')
// // calls server side to make pdf
// const url = `${getBaseName()}pdf/${searchName}.pdf?jwt=${jwt}&searchId=${searchId}&searchName=${searchName}&inputs=${inputs}`
// console.log(url)
